<template>
  <div class="question-paper-catagory">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="分类名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入分类名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd(null)">新增分类</Button>
    </div>
    <div class="content">
      <TreeGrid :rows="list" :columns="columns" :max-level="2">
        <template slot-scope="{row}" slot="c1">
          {{row.name}}
          <span v-if="row.children && row.children.length">（{{row.children.length}}）</span>
        </template>
        <template slot-scope="{row}" slot="action">
          <Button
            type="text"
            size="small"
            @click="onAdd(row)"
            :style="{visibility: row.parent_id ? 'hidden' : 'visible'}"
          >新增</Button>
          <span :style="{visibility: row.parent_id ? 'hidden' : 'visible'}">-</span>
          <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
          <span>-</span>
          <Button type="text" size="small" @click="onDelete(row)">删除</Button>
        </template>
      </TreeGrid>
    </div>
    <Modal v-model="modal.show" :title="modal.title">
      <div>
        <Form ref="modalForm" :model="modal.form" :rules="modal.formRules" :label-width="90">
          <FormItem label="所属分类">{{modal.parentName}}</FormItem>
          <FormItem label="分类名称" prop="name">
            <Input
              v-model="modal.form.name"
              placeholder="分类名称最多输入15个字"
              :maxlength="15"
              style="width:300px;"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="modal.show = false">取消</Button>
        <Button type="primary" @click="onModalOk" :loading="modal.btnLoading">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "question-paper-catagory",
  data() {
    return {
      searchCondition: {
        name: "",
        init() {
          this.name = "";
        }
      },
      list: [],
      columns: [
        { title: "分类名称", slot: "c1" },
        { title: "试卷数量", key: "exam_count", align: "center" },
        { title: "操作", slot: "action", width: 140 }
      ],
      modal: {
        show: false,
        title: "",
        type: "",
        form: {
          name: ""
        },
        formRules: {
          name: [
            { required: true, message: "分类名称不能为空", trigger: "blur" }
          ]
        },
        parentName: "",
        parentID: 0,
        selfID: 0,
        btnLoading: false
      }
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    // on event
    onSearch() {
      this.requestList();
    },
    onReset() {
      this.searchCondition.init();
      this.requestList();
    },
    onAdd(row) {
      this.modal.show = true;
      this.modal.title = "新增分类";
      this.modal.type = "add";
      this.modal.form.name = "";
      if (!row) {
        this.modal.parentName = "无";
        this.modal.parentID = 0;
      } else {
        this.modal.parentName = row.name;
        this.modal.parentID = row.id;
      }
    },
    onEdit(row) {
      this.modal.show = true;
      this.modal.title = "编辑分类";
      this.modal.type = "edit";
      this.modal.parentName = this.getParentName(row.parent_id);
      this.modal.selfID = row.id;
      this.modal.form.name = row.name;
    },
    onDelete(row) {
      if (row.exam_count) {
        this.$Modal.info({
          title: "提示",
          content: "当前分类已被使用，无法删除"
        });
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "确定要删除该分类吗？",
          onOk: () => {
            this.$http.delete(`/api/exam/classify/${row.id}`).then(() => {
              this.$Message.success("删除成功");
              this.requestList();
            });
          }
        });
      }
    },
    onModalOk() {
      this.$refs.modalForm.validate(valid => {
        if (!valid) return;
        this.modal.btnLoading = true;
        if (this.modal.type == "add") {
          this.$http
            .post("/api/exam/classify", {
              parent_id: this.modal.parentID,
              name: this.modal.form.name
            })
            .then(() => {
              this.modal.btnLoading = false;
              this.modal.show = false;
              this.$Message.success("添加成功");
              this.requestList();
            });
        } else {
          this.$http
            .put(`/api/exam/classify/${this.modal.selfID}`, {
              name: this.modal.form.name
            })
            .then(() => {
              this.modal.btnLoading = false;
              this.modal.show = false;
              this.$Message.success("编辑成功");
              this.requestList();
            });
        }
      });
    },
    // other
    getParentName(parentID) {
      for (const i of this.list) {
        if (parentID == i.id) {
          return i.name;
        }
      }
      return "无";
    },
    // request
    requestList() {
      this.$http.get("/api/exam/classify", this.searchCondition).then(data => {
        this.list = data;
        this.list.forEach(i => {
          if (!i.children || !i.children.length) {
            i._disableExpand = true;
          }
        });
      });
    }
  }
};
</script>